import { INTERNAL_URL_REGEX } from "../connectors/LinkConnector";

// Note: target should be a valid target keyword
const targetIsExternal = target => target === "_blank" || target === "EXTERNAL_MODAL";

export const linkMapper = (links = []) =>
	links.map(link => ({
		...link,
		iconName:
			!INTERNAL_URL_REGEX.test(link.url) && targetIsExternal(link.target)
				? "external-micro"
				: undefined,
	}));
